// Devices.js

import React, {Component} from 'react';
import { Button, Form , Container, Row, Col ,  ButtonToolbar, Overlay, Popover } from 'react-bootstrap';
import Config from '../Config';
import ScrollArea from 'react-scrollbar';
import Modal from 'react-awesome-modal';

import { JsonToExcel } from 'react-json-excel';

import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import Column from 'react-virtualized/dist/commonjs/Table/Column';
import Table from 'react-virtualized/dist/commonjs/Table';
import SortDirection from 'react-virtualized/dist/commonjs/Table/SortDirection';
import SortIndicator from 'react-virtualized/dist/commonjs/Table/SortIndicator';
import styles from './Table.css';

// class RowItem extends Component {
//     static defaultProps = {
//         item: null,
//         enable: false,
//         onPress: () => { },
//     }
//     constructor(props) {
//         super(props);
//         this.state = {
//             answervisible : false
//         };
//     }

//     handleRowClick = () => {
//         this.props.onPress(this.props.item);
//         event.preventDefault();
//     }
//     render(){
//         return (
//             <tr onClick={this.handleRowClick}>
//             <td>{this.props.item.EMAIL}</td>
//             <td>{this.props.item.SNS}</td>
//             <td>{this.props.item.OS}</td>
//             <td>{this.props.item.OS_VER}</td>
//             <td>{this.props.item.APP_VER}</td>
//             <td>{this.props.item.DEV_TYPE}</td>
//             <td>{this.props.item.COUNTRY_CODE}</td>
//             <td>{this.props.item.LANGUAGE_CODE}</td>
//             <td>{this.props.item.REGDATE}</td>
//             <td>{this.props.item.TOKEN}</td>
//             <td>{this.props.item.PUSH_TOKEN.length > 0 ? "OK": ""}</td>
//             </tr>
//         );
//     }
// };

const className = 'class-name-for-style',
    filename = 'Devices_Excel-file',
    fields = {
        "EMAIL": "EMAIL",
        "SNS": "SNS",
        "OS": "OS종류",
        "OS_VER": "OS버전",
        "APP_VER": "앱버전",
        "DEV_TYPE": "장치",
        "COUNTRY_CODE": "국가",
        "LANGUAGE_CODE": "언어",
        "REG_DATE": "등록일",
        "TOKEN": "토큰",
        "PUSH_TOKEN": "PUSH",
    },
    style = {
        padding: "5px",
        background: "#3c8dbc",
        border: "1px #367fa9",
        borderRadius: "3px",
        padding: "6px 12px",
        color: "#ffffff",
        font: "14px",
        height: "37.64px"
    }

class Content extends Component {
    static defaultProps = {
        item: null,
        enable: false,
        onPress: () => { },
    }
    constructor(props) {
        super(props);
        this.state = {
            answervisible : false,
            item : this.props.item,
            enable : false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeContent = this.handleChangeContent.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleReset = this.handleReset.bind(this);
        this.handleRemove = this.handleRemove.bind(this);
        this.handleChangeLang = this.handleChangeLang.bind(this);
        this.handleChangeCountry = this.handleChangeCountry.bind(this);
    }
    
    componentWillReceiveProps(nextProps){
        console.log("componentWillReceiveProps: " + JSON.stringify(nextProps));
        this.setState( { item : nextProps.item , enable: nextProps.enable } );
    }

    handleReset(event) {
        this.setState( { item : { PCODE : '상품코드' , USE : '0' , REVIEW : '1' , PIMAGE:  '' ,  BIMAGE:  '', NIMAGE:  '' 
            , LOCALS : '["Eng","Kor","Jpn","Chn"]' , RTMIN : 0, URL : '' , DRM : '' , FILESIZE : 0  } 
            , enable: true });

        event.preventDefault();
    }

    handleChange(event) {
        var item = this.state.item;
        item.TITLE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeContent(event) {
        var item = this.state.item;
        item.CONTENT = event.target.value;
        this.setState({ item: item });
    }

    handleChangeLang(event) {
        var item = this.state.item;
        item.LANGUAGE_CODE = event.target.value;
        this.setState({ item: item });
    }

    handleChangeCountry(event) {
        this.setState({country: event.target.value});
    }
    
    handleSubmit(event) {

        Config.fetchData('insproduct' , {
                PCODE: this.state.item.PCODE,
                USE: this.state.item.USE,
                REVIEW: this.state.item.REVIEW,
                PIMAGE: this.state.item.PIMAGE,
                BIMAGE: this.state.item.BIMAGE,
                NIMAGE: this.state.item.NIMAGE,
                LOCALS: this.state.item.LOCALS,
                RTMIN: this.state.item.RTMIN,
                URL: this.state.item.URL,
                DRM: this.state.item.DRM,
                FILESIZE: this.state.item.FILESIZE
            }, (result, count) => {
                console.log('insproduct=', count);
                this.setState({sendcount : count})
                this.componentDidMount();

            }, true);    

            event.preventDefault();
    }

    handleRemove(event) {

        Config.fetchData('delproduct' , {
            ID : this.state.item.ID,
            COUNTRY_CODE: this.state.item.COUNTRY_CODE,
            LANGUAGE_CODE: this.state.item.LANGUAGE_CODE
        }, (result, count) => {
            console.log('delproduct=', count);
            this.setState({sendcount : count})
            this.componentDidMount();
            
        }, true);    

        event.preventDefault();
    }

    render(){
        return (
            <Form>

                <Button variant="primary" onClick={this.handleSubmit}>저장</Button>
                <Button variant="primary" onClick={this.handleReset}>신규</Button>
                <Button variant="primary" onClick={this.handleRemove}>삭제</Button>

                { this.state.enable && <div>
                    <div className="col-md-6">
                <Form.Row>
                    <Form.Group as={Col}  controlId="exampleForm.ControlInput1">
                        <Form.Label>상품코드</Form.Label>
                        <Form.Control type="title" placeholder="코드를 입력하세요." value={this.state.item.PCODE} onChange={this.handleChange} />
                    </Form.Group>
                    <Form.Group as={Col}  controlId="exampleForm.ControlSelect1">
                        <Form.Label>사용여부</Form.Label>
                        <Form.Control as="select" value={this.state.item.USE} onChange={this.handleChangeLang}>
                        <option>1</option>
                        <option>0</option>
                        </Form.Control>
                    </Form.Group>
                    <Form.Group as={Col} controlId="exampleForm.ControlSelect1">
                        <Form.Label>검수중</Form.Label>
                        <Form.Control as="select" value={this.state.item.REVIEW} onChange={this.handleChangeLang}>
                        <option>1</option>
                        <option>0</option>
                        </Form.Control>
                    </Form.Group>
                </Form.Row>


                <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>전체 이미지</Form.Label>
                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.PIMAGE} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>구매 이미지</Form.Label>
                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.BIMAGE} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>최신 이미지</Form.Label>
                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.NIMAGE} onChange={this.handleChange} />
                </Form.Group>
                </div>
                <div className="col-md-6">
                <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>최신 이미지</Form.Label>
                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.NIMAGE} onChange={this.handleChange} />
                </Form.Group>

                <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>자막 언어</Form.Label>
                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.LOCALS} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>재생시간</Form.Label>
                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.RTMIN} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>미리보기</Form.Label>
                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.URL} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>DRM</Form.Label>
                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.DRM} onChange={this.handleChange} />
                </Form.Group>
                <Form.Group controlId="exampleForm.ControlInput1">
                    <Form.Label>파일크기</Form.Label>
                    <Form.Control type="title" placeholder="파일명 입력하세요." value={this.state.item.FILESIZE} onChange={this.handleChange} />
                </Form.Group>
                </div>
                </div>
                }
                
            </Form>
            
        );
    }
};

  
export default class Devices extends Component {
    
    constructor(props) {
    super(props);

    // const sortBy = 'index';
    // const sortDirection = SortDirection.ASC;
    // const sortedList = this._sortList({sortBy, sortDirection});

    this.state = {
        sendcount : 0,
        results : [],
        rowlist : [],
        answervisible : false,
        scrollToIndex: undefined,
        sortBy: false,
        sortDirection: false,
        sortedList: false,
        item : {  EMAIL : '' , NAME : '' , REGDATE:  ''  }
    };
    this._getRowHeight = this._getRowHeight.bind(this);
    this._headerRenderer = this._headerRenderer.bind(this);
    this._noRowsRenderer = this._noRowsRenderer.bind(this);
    this._onRowCountChange = this._onRowCountChange.bind(this);
    this._onScrollToRowChange = this._onScrollToRowChange.bind(this);
    this._rowClassName = this._rowClassName.bind(this);
    // this._sort = this._sort.bind(this);
    
    }

    handleRowClick = (item) => {
        // alert(item);
        var edititem = {...item};
 

        event.preventDefault();
    }

    handleRowClick = () => {
        this.props.onPress(this.props.item);
        event.preventDefault();
    }

    componentDidMount() {
        Config.fetchData('devicesall' , {
        }, (result, count) => {
            console.log('count=', count);
            this.setState({rowlist : result , results : result})
        }, true);   
    }

    handleClose = () => {
        console.log('handleClose');
        this.setState({answervisible: false });
    }
    
    handleScroll(scrollData){
        console.log(scrollData);
    }

    //Table
    _getDatum(index) {
        return this.state.rowlist[index];
      }
    
      _getRowHeight({index}) {
        const {list} = this.context;
    
        return this._getDatum(list, index).size;
      }
    
      _headerRenderer({dataKey, sortBy, sortDirection}) {
        return (
          <div>
            Email
            {sortBy === dataKey && <SortIndicator sortDirection={sortDirection} />}
          </div>
        );
      }
    
      _isSortEnabled() {
        const {list} = this.state.rowlist;
        const {rowCount} = this.state;
    
        return rowCount <= this.state.rowlist.length;
      }
    
      _noRowsRenderer() {
        return <div className={styles.noRows}>No rows</div>;
      }
    
      _onRowCountChange(event) {
        const rowCount = parseInt(event.target.value, 10) || 0;
    
        this.setState({rowCount});
      }
    
      _onScrollToRowChange(event) {
        const {rowCount} = this.state;
        let scrollToIndex = Math.min(
          rowCount - 1,
          parseInt(event.target.value, 10),
        );
    
        if (isNaN(scrollToIndex)) {
          scrollToIndex = undefined;
        }
    
        this.setState({scrollToIndex});
      }
    
      _rowClassName({index}) {
        if (index < 0) {
          return "headerRow";
        } else {
          return index % 2 === 0 ? "evenRow" : "oddRow";
        }
      }
    
    //   _sort({sortBy, sortDirection}) {
    //     const sortedList = this._sortList({sortBy, sortDirection});
    
    //     this.setState({sortBy, sortDirection, sortedList});
    //   }
    
    //   _sortList({sortBy, sortDirection}) {
    //     const {list} = this.state.rowlist;
    
    //     return list
    //       .sortBy(item => item[sortBy])
    //       .update(list =>
    //         sortDirection === SortDirection.DESC ? list.reverse() : list,
    //       );
    //   }

    onClickSearch = () => {
        if (this.state.searchText.trim().length < 1) {
            this.setState({ rowlist: this.state.results });
        } else {
            this.setState({ rowlist: this.state.results.filter(item => item.EMAIL.includes(this.state.searchText.trim())) });
        }
    }

    handleSearchChange = (event) => {
        event.preventDefault(); // form의 기본 제출 동작을 방지합니다.
        var newValue = this.state.searchText;
        newValue = event.target.value;
        this.setState({ searchText: newValue }, () => {
            this.onClickSearch();
        });
    };

    render(){
        let scrollbarStyles = {borderRadius: 5};
        // const rowGetter = ({index}) => this._getDatum(sortedList, index);
        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box">
                                <div className="box-header with-border">
                                    <table>
                                        <tr>
                                            <td>
                                                <h3 className="box-title">이용자관리</h3>
                                            </td>
                                            <td width="16"></td>
                                            <td>
                                                <Form style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <Form.Control type="title" value={this.state.searchText} onChange={this.handleSearchChange} placeholder="EMAIL을 입력하세요." />
                                                    <Button variant="primary" onClick={this.onClickSearch}>검색</Button>
                                                </Form>
                                            </td>
                                            <td width="16"></td>
                                            <td>
                                                {this.state.rowlist.length > 0 ?
                                                    <JsonToExcel
                                                        data={this.state.rowlist}
                                                        className={className}
                                                        filename={filename}
                                                        fields={fields}
                                                        style={style}
                                                    />
                                                    :
                                                    null
                                                }
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div className="box-body" style={{  margin: 20 }}>
                                    <div className="row">
                                        <AutoSizer disableHeight>
                                            {({width}) => (
                                            <Table
                                                ref="Table"
                                                headerClassName={'headerColumn'}
                                                onRowClick={this.handleRowClick}
                                                headerHeight={30}
                                                height={800}
                                                noRowsRenderer={this._noRowsRenderer}
                                                overscanRowCount={10}
                                                rowClassName={this._rowClassName}
                                                rowHeight={40}
                                                rowGetter={({index}) => this.state.rowlist[index]}
                                                rowCount={this.state.rowlist.length}
                                                scrollToIndex={this.state.scrollToIndex}
                                                // sort={this._sort}
                                                // sortBy={sortBy}
                                                // sortDirection={sortDirection}
                                                width={width}>
                                                <Column
                                                width={300}
                                                disableSort
                                                label="EMAIL"
                                                dataKey="EMAIL"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={100}
                                                disableSort
                                                label="SNS"
                                                dataKey="SNS"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={100}
                                                disableSort
                                                label="OS종류"
                                                dataKey="OS"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={100}
                                                disableSort
                                                label="OS버전"
                                                dataKey="OS_VER"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={100}
                                                disableSort
                                                label="앱버전"
                                                dataKey="APP_VER"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={100}
                                                disableSort
                                                label="장치"
                                                dataKey="DEV_TYPE"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={70}
                                                disableSort
                                                label="국가"
                                                dataKey="COUNTRY_CODE"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={70}
                                                disableSort
                                                label="언어"
                                                dataKey="LANGUAGE_CODE"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={150}
                                                disableSort
                                                label="등록일"
                                                dataKey="REG_DATE"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={300}
                                                disableSort
                                                label="토큰"
                                                dataKey="TOKEN"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData}
                                                flexGrow={1}
                                                />
                                                <Column
                                                width={100}
                                                disableSort
                                                label="PUSH"
                                                dataKey="PUSH_TOKEN"
                                                className={'exampleColumn'}
                                                cellRenderer={({cellData}) => cellData.length > 0 ? "OK": ""}
                                                flexGrow={1}
                                                />
                                            </Table>
                                            )}
                                        </AutoSizer>
                                        {/* <ScrollArea style={{  width: '100%' , height: 700 }}
                                            className="area"
                                            contentClassName="content"
                                            verticalScrollbarStyle={scrollbarStyles}
                                            verticalContainerStyle={scrollbarStyles}
                                            horizontalScrollbarStyle={scrollbarStyles}
                                            horizontalContainerStyle={scrollbarStyles}
                                            smoothScrolling= {true}
                                            minScrollSize={5}
                                            onScroll={this.handleScroll}
                                            >
                                        <Table striped bordered hover>
                                        <thead>
                                            <tr>
                                            <td>EMAIL</td>
                                            <td>SNS</td>
                                            <td>OS종류</td>
                                            <td>OS버전</td>
                                            <td>앱버전</td>
                                            <td>장치</td>
                                            <td>국가</td>
                                            <td>언어</td>
                                            <td>등록일</td>
                                            <td>토큰</td>
                                            <td>PUSH</td>
                                            </tr>
                                        </thead>
                                        <tbody>

                                        { this.state.rowlist.map((item, index) =>
                                            <RowItem key={index} item={item} onPress={this.handleRowClick}/>
                                        )}

                                        </tbody>
                                        </Table>
                                        </ScrollArea> */}
                                    </div>
                                    
                                </div>
                                <div className="box-footer">
                                    <div className="row">
                                        <div className="col-sm-3 col-xs-6">
                                            <div className="description-block border-right">
                                                {/* <span className="description-percentage text-green"><i className="fa fa-caret-up"></i> 17%</span> */}
                                                {/* <h5 className="description-header">Sending TOTAL: {this.state.sendcount}</h5> */}
                                            </div>
                                        </div>    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// src/components/Devices.js